import { makeAutoObservable } from 'mobx';

import { RalAttributeState } from '@/elements/attributes/RalAttribute/RalAttributeState';

export enum OptionsViewStateName {
  INITIAL = 'INITIAL',
  SELECT_CUSTOM_COLOR = 'SELECT_CUSTOM_COLOR',
}

type OptionsViewState =
  | {
      name: OptionsViewStateName.INITIAL;
    }
  | {
      name: OptionsViewStateName.SELECT_CUSTOM_COLOR;
      state: RalAttributeState;
    };

export class OptionsConfiguratorUIStore {
  view: OptionsViewState = {
    name: OptionsViewStateName.INITIAL,
  };

  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  setView(view: OptionsViewState) {
    this.view = view;
  }

  setInitialView() {
    this.view = {
      name: OptionsViewStateName.INITIAL,
    };
  }
}
